<header class="" id="navbar">
  <div class="container">
    <nav class="navbar navbar-expand-lg navbar-light main-nav bg-li ght  mx-0 px-0">
      <a class="navbar-brand" href="/admin/new-dashboard">
        <img loading="lazy" src="../../../assets/images/logo.png">
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ml-auto">

          <!-- <li class="nav-item">
                      <a class="nav-link" (click)="showSearchModal()"><img loading="lazy" src="../../../../assets/images/srch.png" ></a>
                    </li> -->

          <!-- <div class="dropdown notifications">
                        <button class=" dropdown-toggle" type="button" data-toggle="dropdown" style="outline: none;"> <img loading="lazy" src="../../../../assets/images/noti.png">
                        </button>
                       
                        <ul class="dropdown-menu">
                          <li>Friday, 31 Jan</li>
                          <li class="noti_in">
                              <div class="media position-relative ">
                                <img loading="lazy" src="../../../../assets/images/man.png" class="mr-3" alt="...">
                                <div class="media-body">
                                  <h5 class="">Mark West</h5>
                                  <h6> Sub Admin XXX has added 97860928 as a new member.</h6>
                                  <p>31 Jan 2020  09:30 PM</p>
                                </div>
                            </div>
                          </li> 
                        </ul>
                      </div> -->
          <div class="dropdown profiles">
            <button class=" dropdown-toggle" type="button" data-toggle="dropdown" style="outline: none;"> <img
                loading="lazy" [src]="imgUrl" (error)="onImgError($event)">Name
              <span class="caret"></span></button>
            <ul class="dropdown-menu">
              <li><a id="sub_ul" [routerLink]="['/admin/profile']">Setting</a></li>
              <li><a id="sub_ul" (click)="logout()">Logout</a></li>
            </ul>
          </div>
          <!-- <li class="nav-item sign_up">
                        <a class="nav-link">Member Sign In </a>
                        <a class="nav-link" (click)="showMemberSignup()">Member Sign Up </a>
                        </li> -->
        </ul>
      </div>
    </nav>


  </div>
</header>